import { streemLogger } from './streem_logger';
export const getPermissionsState = async () => {
    // The permissions we can query:
    // https://developer.mozilla.org/en-US/docs/Web/API/Permissions/query#name
    // Firefox does not support querying by 'camera' or 'microphone' so this will not work.
    let camera = undefined;
    let microphone = undefined;
    try {
        // @ts-ignore 'camera' is not a valid permission name because it's not supported in Firefox
        camera = await navigator.permissions.query({ name: 'camera' });
    }
    catch (e) {
        if (e instanceof Error)
            streemLogger.info('Unable to determine permissions for camera: ', e.message);
    }
    try {
        microphone = await navigator.permissions.query({
            // @ts-ignore 'microphone' is not a valid permission name because it's not supported in Firefox
            name: 'microphone',
        });
    }
    catch (e) {
        if (e instanceof Error)
            streemLogger.info('Unable to determine permissions for microphone: ', e.message);
    }
    return {
        camera: camera?.state,
        microphone: microphone?.state,
    };
};
//# sourceMappingURL=permission_state.js.map